function convertMinsToTimestamp(mins) {
  let h = Math.floor(mins / 60);
  let m = mins % 60;
  h = String(h).padStart(2, '0');
  m = String(m).padStart(2, '0');
  const time = `${h}:${m}:00`;
  return time.startsWith('00:') ? time.slice(3) : time;
}

export { convertMinsToTimestamp };
